import appConfig from '~/config/app'
import useCurrentFamily from '~/familyAccount/hooks/useCurrentFamily'
import useCurrentUser from '~/hooks/useCurrentUser'

interface MenuSubscriptionState {
  isSubscriptionApplicable: boolean
  showFamilyFeatures: boolean
}

export default function useMenuSubscriptionState(): MenuSubscriptionState {
  const user = useCurrentUser()
  const { hasFamily } = useCurrentFamily()

  const isSubscriptionApplicable = Boolean(user?.isSubscriptionApplicable)

  return {
    isSubscriptionApplicable,
    // Family entry points (switch profile, family admin panel) lead to pages that cannot render
    // without a family, so they belong to people who have one — country and subscription say
    // nothing about that. Offering them as an upsell strands the user on a page that never loads.
    //
    // The school gate stays on top of that: the whole /family tree 404s in the school platform, and
    // `hasFamily` is derived from API data (useCurrentFamily), so it is not the frontend's call
    // whether a school seat can come back carrying family members. Without this term, both consumers
    // — the profile switcher and the parent-panel link in MenuUtilityLinks — would render links into
    // a 404 if it ever did.
    showFamilyFeatures: !appConfig.isSchoolPlatform && hasFamily,
  }
}
